// these values are mirrored on the server:
const ALL_AUTO_MTT_FREQUENCY_UNIT_TYPES = ['hours', 'days', 'weeks', 'months'];
export function isAutoMttFrequencyUnitType(val) {
    return typeof val === 'string' && ALL_AUTO_MTT_FREQUENCY_UNIT_TYPES.includes(val);
}
const FREQUENCY_SINGULAR_UNITS = {
    hours: 'hour',
    days: 'day',
    weeks: 'week',
    months: 'month'
};
export function getFrequencyString(frequencyCount, frequencyUnitType) {
    return `${frequencyCount} ${FREQUENCY_SINGULAR_UNITS[frequencyUnitType]}${frequencyCount > 1 ? 's' : ''}`;
}
const ALL_AUTO_MTT_RECENT_HANDS_TYPES = ['regular', 'tourney', 'any'];
export function isAutoMttRecentHandsType(val) {
    return typeof val === 'string' && ALL_AUTO_MTT_RECENT_HANDS_TYPES.includes(val);
}
